import React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import { useForm } from 'react-hook-form';
import DepositReconciliation from '../models/depositReconciliation';

interface IApplyOverpaymentDialogProps {
    dialogName: string;
    hideDialog: () => void;
    invoice: DepositReconciliation;
    onApply: (amount: number) => void;
}

const ApplyOverpaymentDialog = (props: IApplyOverpaymentDialogProps) => {
    const { register, getValues } = useForm();

    const OKClicked = () => {
        const amount = Number(getValues().amount);
        if (isNaN(amount)) {
            return;
        }
        props.onApply(amount);
    };

    return (
        <Dialog title="Apply Overpayment" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '20%' }}>
            <form key={props.invoice?.entryNumber}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'left', flexDirection: 'column' }}>
                    <RHFInputBox
                        label="Invoice Type"
                        labelStyle={{ width: '9rem', display: 'inline-block', whiteSpace: 'nowrap' }}
                        labelOnLeft={true}
                        name={'invoiceType'}
                        type="text"
                        defaultVal={props.invoice?.description}
                        register={register}
                        readOnly={true}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                    <RHFInputBox
                        label="Invoice #"
                        labelStyle={{ width: '9rem', display: 'inline-block', whiteSpace: 'nowrap' }}
                        labelOnLeft={true}
                        name={'referenceNumber'}
                        type="text"
                        defaultVal={props.invoice?.referenceNumber}
                        register={register}
                        readOnly={true}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                    <RHFInputBox
                        label="Description"
                        labelStyle={{ width: '9rem', display: 'inline-block', whiteSpace: 'nowrap' }}
                        labelOnLeft={true}
                        name={'remarks'}
                        type="text"
                        defaultVal={props.invoice?.remarks}
                        register={register}
                        readOnly={true}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                    <RHFInputBox
                        label="Invoice Amount"
                        labelStyle={{ width: '9rem', display: 'inline-block', whiteSpace: 'nowrap' }}
                        labelOnLeft={true}
                        name={'invoiceAmount'}
                        type="text"
                        defaultVal={props.invoice?.amount != null ? props.invoice.amount.toString() : ''}
                        register={register}
                        readOnly={true}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                    <RHFInputBox
                        label="Invoice Date"
                        labelStyle={{ width: '9rem', display: 'inline-block', whiteSpace: 'nowrap' }}
                        labelOnLeft={true}
                        name={'invoiceDate'}
                        type="text"
                        defaultVal={props.invoice?.transactionDate ? new Date(props.invoice.transactionDate).toLocaleDateString() : ''}
                        register={register}
                        readOnly={true}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                    <RHFInputBox
                        label="Amount"
                        labelStyle={{ width: '9rem', display: 'inline-block', whiteSpace: 'nowrap' }}
                        labelOnLeft={true}
                        name={'amount'}
                        type="text"
                        register={register}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </div>
                <div className="form-row" style={{ marginTop: '2rem', justifyContent: 'center' }}>
                    <Button
                        className="blue-hover-button"
                        style={{ width: '24%', marginRight: '1rem' }}
                        text={'OK'}
                        onClick={() => OKClicked()}
                    />
                    <Button
                        className="blue-hover-button"
                        style={{ width: '24%', marginRight: '1rem' }}
                        text={'Cancel'}
                        onClick={() => props.hideDialog()}
                    />
                </div>
            </form>
        </Dialog>
    );
};

export default ApplyOverpaymentDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-receivable/dialogs/ApplyOverpaymentDialog.tsx